exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fee-input[data-v-8ef307b2] {\n  max-width: 50px;\n}\n.fee-input[data-v-8ef307b2]::-webkit-inner-spin-button,\n.fee-input[data-v-8ef307b2]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  margin: 0;\n}\n.name-type-div[data-v-8ef307b2] {\n  display: flex;\n  justify-content: center;\n}\n.type-div[data-v-8ef307b2] {\n  padding-top: 15px;\n  width: 200px;\n  margin-bottom: 65px;\n  margin-left: 30px;\n}", ""]);

// exports
